import React from "react";
import { authContext } from "../providers/AuthProvider";
function useAuth() {
  const auth = React.useContext(authContext);

  return auth;
}
export default useAuth;
